import { Routes } from '@angular/router';
import { AppGuard } from './guard/appguard.guard';
import { AdminGuard } from './guard/adminguard.guard';

const appModule = () => import('../app/application/application.module').then(x => x.ApplicationModule);
const adminModule = () => import('../app/admin/admin.module').then(x => x.AdminModule);
const loginModule = () => import('../app/login/login.module').then(x=>x.LoginModule);
const offRoadModule = () => import('../app/offroad/offroad.module').then(x=>x.OffroadModule);

export const routes: Routes = [
    {path:'offroad', title:'Off Road', loadChildren: offRoadModule, canActivate:[AppGuard]},
    {path:'regocheck', title:'Company', loadChildren: appModule, canActivate:[AppGuard]},
    {path:'admin', title:'Admin', loadChildren: adminModule, canActivate:[AdminGuard]},
    {path:'', title:'NZTA Link', loadChildren: loginModule}  
];
